// TOP ヒーローFV（PC/SP各4枚・約2秒でフェード切替）
const main = () => {
    const slider = document.querySelector(".js-hero-slider");
    if (!slider) return;

    const slides = slider.querySelectorAll(".p-home-hero__slide");
    if (slides.length <= 1) return;

    let index = 0;
    let timer = null;
    const AUTO_MS = Number(slider.dataset.interval) || 3000;

    const go = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((slide, si) => {
            slide.classList.toggle("is-active", si === index);
        });
    };

    const next = () => go(index + 1);

    const start = () => {
        stop();
        timer = window.setInterval(next, AUTO_MS);
    };

    const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
    };

    // タブ非表示中は止めて、復帰時に再開
    document.addEventListener("visibilitychange", () => {
        if (document.hidden) stop();
        else start();
    });

    go(0);
    start();
};

export default main;
